import React from 'react';
import PropTypes from 'prop-types';

export const Delete = ({ width, height, ...props }) => (
  <svg
    data-icon='delete'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M7 21c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 5 19V6H4V4h5V3h6v1h5v2h-1v13c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 17 21H7ZM17 6H7v13h10V6ZM9 17h2V8H9v9Zm4 0h2V8h-2v9Z'
    />
  </svg>
);

Delete.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Delete.defaultProps = {
  width: 24,
  height: 24,
};
